import i18n from 'i18n'

export function randomIntFromInterval(min, max) {
	return Math.floor(Math.random() * (max - min + 1) + min)
}

export function getUrlParamsFromJson(data) {
	return Object.keys(data)
		.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
		.join('&')
}
export const hidePhoneNumberMiddle = phoneNumber => {
	// Kiểm tra xem số điện thoại có hợp lệ (ít nhất 7 ký tự) hay không
	if (typeof phoneNumber !== 'string' || phoneNumber.length < 7) {
		return phoneNumber
	}

	// Chuyển 4 ký tự giữa thành dấu '*'
	const startDigits = phoneNumber.slice(0, 3)
	const middleHidden = '*'.repeat(4)
	const endDigits = phoneNumber.slice(-(phoneNumber.length - 7))

	return startDigits + middleHidden + endDigits
}
export const handleFlyWater = iconDrop => {
	const speed = 5000,
		curveDelay = 300,
		position = 'fixed'
	let iconEvent = document.querySelector('#icon-event')
	let iconWater = document.querySelector('#show-water')
	let img = document.createElement('img')
	img.src = iconDrop
	iconWater.style.position = position
	iconWater.style.top = '50vh'
	iconWater.style.left = '50vw'
	iconWater.style.opacity = '1'
	iconWater.style.transition = `all ${speed / 1000}s ease, top ${(speed + curveDelay) / 1000
		}s ease, left ${speed / 1000}s ease, transform ${speed / 3000}s ease ${(speed - 10) / 3000
		}s`

	let flyingBtn = iconWater.cloneNode()

	document.body.appendChild(flyingBtn)
	let rect = iconEvent.getBoundingClientRect()
	flyingBtn.style.top = `${rect.top}px`
	flyingBtn.style.left = `${rect.left + iconEvent.offsetHeight / 2}px`
	flyingBtn.style.width = '65px'
	flyingBtn.style.transform = 'scale(0)'
	flyingBtn.style.zIndex = '9999'
	flyingBtn.appendChild(img)
	setTimeout(() => {
		flyingBtn.remove()
	}, speed * 1.5)
}

export const handleFlyBoatRacing = (iconDrop, turn_num) => {
	const speed = 5000,
		curveDelay = 300,
		position = 'fixed'
	let iconEvent = document.querySelector('#icon-event-boat-racing')
	let iconBoatRacing = document.querySelector('#show-boat-racing')
	let img = document.createElement('img')
	let turnNum = document.createElement('div')
	turnNum.innerHTML = `+${turn_num}`
	turnNum.style.position = 'absolute'
	turnNum.style.top = '50%'
	turnNum.style.left = '50%'
	turnNum.style.transform = 'translate(-50%, -50%)'
	turnNum.style.color = 'hsl(11deg 85% 55% / 100%)'
	turnNum.style.fontSize = '20px'
	turnNum.style.fontWeight = 'bold'

	img.src = iconDrop
	iconBoatRacing.style.position = position
	iconBoatRacing.style.top = '50vh'
	iconBoatRacing.style.left = '50vw'
	iconBoatRacing.style.opacity = '1'
	iconBoatRacing.style.transition = `all ${speed / 1000}s ease, top ${(speed + curveDelay) / 1000
		}s ease, left ${speed / 1000}s ease, transform ${speed / 3000}s ease ${(speed - 10) / 3000
		}s`

	let flyingBtn = iconBoatRacing.cloneNode()

	document.body.appendChild(flyingBtn)
	let rect = iconEvent.getBoundingClientRect()
	flyingBtn.style.top = `${rect.top}px`
	flyingBtn.style.left = `${rect.left + iconEvent.offsetHeight / 2}px`
	flyingBtn.style.width = '65px'
	flyingBtn.style.transform = 'scale(0)'
	flyingBtn.style.zIndex = '9999'
	flyingBtn.appendChild(img)
	if (turn_num) {
		flyingBtn.appendChild(turnNum)
	}
	setTimeout(() => {
		flyingBtn.remove()
	}, speed * 1.5)
}

export const handleFlyItem = (iconDrop, idEvent, idItem) => {
	const speed = 5000,
		curveDelay = 300,
		position = 'fixed'
	let iconEvent = document.getElementById(idEvent)
	let iconWater = document.getElementById(idItem)
	let img = document.createElement('img')
	img.src = iconDrop
	iconWater.style.position = position
	iconWater.style.top = '50vh'
	iconWater.style.left = '50vw'
	iconWater.style.opacity = '1'
	iconWater.style.transition = `all ${speed / 1000}s ease, top ${(speed + curveDelay) / 1000
		}s ease, left ${speed / 1000}s ease, transform ${speed / 3000}s ease ${(speed - 10) / 3000
		}s`

	let flyingBtn = iconWater.cloneNode()

	document.body.appendChild(flyingBtn)
	let rect = iconEvent.getBoundingClientRect()
	flyingBtn.style.top = `${rect.top}px`
	flyingBtn.style.left = `${rect.left + iconEvent.offsetHeight / 2}px`
	flyingBtn.style.width = '65px'
	flyingBtn.style.transform = 'scale(0)'
	flyingBtn.style.zIndex = '9999'
	flyingBtn.appendChild(img)
	setTimeout(() => {
		flyingBtn.remove()
	}, speed * 1.5)
}

export const handleRunBoat = (
	position,
	isMobile,
	isMobileSm,
	callback = () => { },
	isStop,
) => {
	if (position) {
		const element = document.getElementById('boat-running-event')
		if (element) {
			element.classList.add('boat-run')
			if (isMobileSm) {
				element.style.top = `${(position.top * 320) / 482 - 15}px`
				element.style.left = `${(position.left * 402) / 605 - 30}px`
			} else if (isMobile) {
				element.style.top = `${(position.top * 400) / 482 - 15}px`
				element.style.left = `${(position.left * 502) / 605 - 30}px`
			} else {
				element.style.top = `${position.top - 15}px`
				element.style.left = `${position.left - 30}px`
			}
			element.style.animation = 'none'
			element.style.transition = 'top 0.5s , left 0.5s ease-in-out'
			if (isStop) {
				setTimeout(() => {
					element.classList.remove('boat-run')
					if (isMobileSm) {
						element.style.top = `${(position.top * 320) / 482 - 10}px`
						element.style.left = `${(position.left * 402) / 605 - 20}px`
					} else if (isMobile) {
						element.style.top = `${(position.top * 400) / 482 - 10}px`
						element.style.left = `${(position.left * 502) / 605 - 20}px`
					} else {
						element.style.top = `${position.top - 10}px`
						element.style.left = `${position.left - 20}px`
					}
					callback()

					element.style.transition = 'width 0.1s , height 0.1s ease-in-out'
					element.style.animation = 'boxBounce 4.5s both infinite'
				}, 500)
			}
			return new Promise(resolve => setTimeout(resolve, 500))
		}
	}
}
export function animateValue(obj, start, end, duration) {
	let startTimestamp = null

	const step = timestamp => {
		if (!startTimestamp) startTimestamp = timestamp
		const progress = Math.min((timestamp - startTimestamp) / duration, 1)
		obj.innerHTML = `${i18n.t('event.boat_racing.home.step')} ${Math.floor(progress * (end - start) + start) || 0
			}`
		if (progress < 1) {
			window.requestAnimationFrame(step)
		}
	}
	window.requestAnimationFrame(step)
}
export const setPositionBoat = (position, isMobileMd, isMobile) => {
	if (position) {
		const element = document.getElementById('boat-running-event')
		if (element) {
			if (isMobile) {
				element.style.top = `${(position.top * 320) / 482 - 10}px`
				element.style.left = `${(position.left * 402) / 605 - 20}px`
			} else if (isMobileMd) {
				element.style.top = `${(position.top * 400) / 482 - 10}px`
				element.style.left = `${(position.left * 502) / 605 - 20}px`
			} else {
				element.style.top = `${position.top - 10}px`
				element.style.left = `${position.left - 20}px`
			}
		}
	}
}
